import { api } from "@/lib/api";

const SW_URL = "/sw.js";

const urlBase64ToUint8Array = (base64String) => {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  const out = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) out[i] = raw.charCodeAt(i);
  return out;
};

export const pushSupported = () =>
  "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;

export const registerSW = async () => {
  if (!pushSupported()) return null;
  const existing = await navigator.serviceWorker.getRegistration(SW_URL);
  if (existing) return existing;
  return navigator.serviceWorker.register(SW_URL);
};

export const getCurrentSubscription = async () => {
  if (!pushSupported()) return null;
  const reg = await registerSW();
  if (!reg) return null;
  return reg.pushManager.getSubscription();
};

export const subscribeToPush = async (locale = "de") => {
  if (!pushSupported()) throw new Error("Push wird in diesem Browser nicht unterstützt.");
  if (Notification.permission === "denied")
    throw new Error("Benachrichtigungen sind blockiert. Bitte in den Browser-Einstellungen erlauben.");

  const reg = await registerSW();
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    const { data } = await api.get("/push/vapid-public-key");
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(data.publicKey),
    });
  }
  const json = sub.toJSON();
  await api.post("/push/subscribe", {
    endpoint: json.endpoint,
    keys: json.keys,
    locale,
    user_agent: navigator.userAgent,
  });
  return sub;
};

export const unsubscribeFromPush = async () => {
  if (!pushSupported()) return;
  const reg = await registerSW();
  const sub = await reg.pushManager.getSubscription();
  if (!sub) return;
  const endpoint = sub.endpoint;
  await sub.unsubscribe();
  try {
    await api.post("/push/unsubscribe", { endpoint });
  } catch {
    /* ignore */
  }
};
